import type { Dataset, MLModel, User } from './customTypes';

const readJSON = <T>(json: string | null | undefined): T => {
  if (json === null || json === undefined || json === '') {
    return {} as unknown as T;
  }
  if (typeof json === 'object') {
    return json;
  }
  return JSON.parse(json) as T;
};

export const KeyFieldPolicies = {
  Annotation: {
    keyFields: ['annotationId'],
  },
  AnnotationMap: {
    keyFields: ['mapId'],
  },
  Channel: {
    keyFields: ['channelId'],
  },
  Dataset: {
    keyFields: ['datasetId'],
    fields: {
      source: {
        read(source: string | null | undefined) {
          return readJSON<Dataset['source']>(source);
        },
      },
    },
  },
  DatasetJob: {
    keyFields: ['datasetId'],
  },
  Editor: {
    keyFields: ['editorId'],
  },
  FoundationModel: {
    keyFields: ['modelId'],
  },
  GANModel: {
    keyFields: ['modelId'],
  },
  Graph: {
    keyFields: ['graphId'],
  },
  Member: {
    keyFields: ['userId', 'email'],
  },
  MLArchitecture: {
    keyFields: ['architectureId'],
  },
  MLInference: {
    keyFields: ['inferenceId'],
  },
  MLModel: {
    keyFields: ['modelId'],
    fields: {
      metrics: {
        read(metrics: string | null | undefined) {
          return readJSON<MLModel['metrics']>(metrics);
        },
      },
      parameters: {
        read(parameters: string | null | undefined) {
          return readJSON<MLModel['parameters']>(parameters);
        },
      },
    },
  },
  Organization: {
    keyFields: ['organizationId'],
  },
  OrganizationSetting: {
    keyFields: ['organizationId', 'setting'],
  },
  Preview: {
    keyFields: ['previewId'],
  },
  RemoteDevelopment: {
    keyFields: ['editorSessionId'],
  },
  Secret: {
    keyFields: ['secretId'],
  },
  Service: {
    keyFields: ['serviceId'],
  },
  Umap: {
    keyFields: ['umapId'],
  },
  User: {
    keyFields: ['userId'],
    fields: {
      preference: {
        read(preference: string | null | undefined) {
          return readJSON<User['preference']>(preference);
        },
      },
    },
  },
  Volume: {
    keyFields: ['volumeId'],
  },
  VolumeData: {
    keyFields: ['key'],
  },
  Workspace: {
    keyFields: ['workspaceId'],
  },
  WorkspaceTemplate: {
    keyFields: ['templateId'],
  },
};
